import { Api } from 'models/services/api';
import { DeleteSupplierQuery } from 'models/services/graphql';

import { SupplierData } from '../index';

type DataToDelete = {
  id: string;
};

const RequestQuery = `
  mutation DeleteSupplier($id: ID!) {
    ${DeleteSupplierQuery}
  }
`;

type ResponseData = {
  data: {
    deleteSupplier: SupplierData
  }
}

class DeleteGql {

  readonly api: Api<ResponseData>;
  readonly document?: SupplierData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToDelete): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.deleteSupplier;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { DeleteGql };